import { render } from "solid-js/web";
import "./fonts.css";
import "./admin.css";
import { AdminApp } from "./AdminApp";
import { createAdminApi } from "./api";
import { createFetchHttp } from "~/lib/http";

const root = document.getElementById("root");
if (!root) throw new Error("Admin root element is missing");

// Einmal erzeugen: Solid macht aus Funktionsaufrufen in JSX-Attributen sonst Getter, die bei jedem Zugriff eine neue Instanz bauen würden.
const api = createAdminApi(createFetchHttp());

render(() => <AdminApp api={api} />, root);
